import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useApi } from "../../lib/useApi";
import { api } from "../../lib/api";
import { Loader, ErrorState, EmptyState, PageHeader } from "../../components/common/States";
import { fmtDate } from "../../lib/labels";

export default function UserNotifications() {
  const { data, loading, error, reload } = useApi("/me/notifications");
  const navigate = useNavigate();
  const open = async (n) => {
    if (!n.read) { await api.post(`/me/notifications/${n.id}/read`); reload(); }
    if (n.link) navigate(n.link);
  };
  return (
    <div className="max-w-3xl">
      <PageHeader title="Notifications" description="Réponses des organisations, demandes de précision et changements de statut."
        actions={data?.unread > 0 && <Button variant="outline" size="sm" onClick={async () => { await api.post("/me/notifications/read-all"); reload(); }} data-testid="user-notifications-read-all">Tout marquer comme lu</Button>} />
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && !data.items.length && <EmptyState icon={Bell} title="Aucune notification" text="Vous serez prévenu ici dès qu'une organisation traitera l'un de vos dossiers." />}
      {data && data.items.length > 0 && (
        <div className="card-surface divide-y">
          {data.items.map((n) => (
            <button key={n.id} onClick={() => open(n)} data-testid={`user-notification-${n.id}`}
              className={`block w-full px-5 py-4 text-left transition-colors hover:bg-slate-50 ${n.read ? "" : "bg-emerald-50/60"}`}>
              <div className="flex items-center gap-2">{!n.read && <span className="h-2 w-2 rounded-full bg-emerald-500" />}<p className="font-medium">{n.title}</p></div>
              <p className="mt-0.5 line-clamp-2 text-sm text-slate-600">{n.message}</p>
              <p className="mt-1 text-xs text-slate-400">{fmtDate(n.created_at)}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
